import { useEffect, useState } from 'react';
/**
 * A React hook that tracks the state of a CSS media query.
 *
 * @param options - Configuration object containing the media query string
 * @returns Boolean indicating whether the media query matches
 *
 * @example
 * ```tsx
 * const isDesktop = useMediaQuery({ query: '(min-width: 1150px)' });
 * const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
 * ```
 */
export const useMediaQuery = ({ query }) => {
    const [matches, setMatches] = useState(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia === 'undefined') {
            return false;
        }
        return window.matchMedia(query).matches;
    });
    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia === 'undefined') {
            return;
        }
        const mediaQueryList = window.matchMedia(query);
        const handleChange = (event) => {
            setMatches(event.matches);
        };
        setMatches(mediaQueryList.matches);
        mediaQueryList.addEventListener('change', handleChange);
        return () => {
            mediaQueryList.removeEventListener('change', handleChange);
        };
    }, [query]);
    return matches;
};
//# sourceMappingURL=use_media_query.js.map